import styled from 'styled-components';

/**
 * Layout only - the events page's filter grid (`eventsFilters/EventsFilters.styles.tsx`): one
 * cell per labelled control, 16 px apart, bottoms aligned so the range toggle, the datepickers and
 * the selects sit on one baseline whatever their label. Cells wrap on their own at narrow widths.
 */
export const Bar = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  align-items: end;
  padding: 8px 0 12px;
`;

/** Six toggles side by side need two cells. */
export const RangeField = styled.div`
  grid-column: span 2;
`;

/** A select with its action beside it, so the toolbar never wraps a lone icon button. */
export const FieldWithAction = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;

  & > :first-child {
    flex-grow: 1;
    min-width: 0;
  }
`;

/** Keeps a bare icon button at its natural width instead of stretching across the cell. */
export const Action = styled.div`
  display: flex;
  justify-content: flex-start;
`;
